import React from "react"
import "twin.macro"
import profile from "../../images/background.jpg"

const HeroSection = () => {
  return (
    <div
      style={{ backgroundImage: `url(${profile})` }}
      tw="text-7xl flex flex-col justify-center items-center text-white
       space-y-5 bg-cover bg-center bg-no-repeat text-center min-height[90vh] font-extrabold  "
      id="HEROSECTION"
    >
      Name of Client
      <div tw="text-5xl  font-bold">Role</div>
    </div>
  )
}

export default HeroSection
